export enum CALENDAR_FILTER_TYPES {
  EMPLOYEE,
  STORE,
  STATUS,
  AMOUNT,
  INTERVAL,
}
